import CrudModule from "@/components/CrudModule";
import { MODULES } from "@/config/modules";
export default function Requote() {
  return <CrudModule module={MODULES.requotes} subtitle="Delayed, declined or changed cases — pivot carriers, run InstaBrain, revise offers." />;
}
